<template lang="pug">
div
    stock-check-list
    stock-check-variance
</template>

<script>
import stockCheckList from './stock-check-list.vue';
import stockCheckVariance from './stock-check-variance.vue';

export default {
    components: {
        stockCheckList,
        stockCheckVariance,
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_check/stock-check-index.vue